var _circle, _circle2, _path, _circle3, _circle4, _path2, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 526.83,
    cy: 1532.58,
    fill: "#e9e7ff",
    r: 145.74
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.83,
    cy: 1532.58,
    fill: "#d8d7f9",
    r: 114.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.31,1523.47a44.19,44.19,0,0,0-11.78-4.06,153.35,153.35,0,0,0-18.35-2.64q-12.6-1.11-17.41-3.45a13.18,13.18,0,0,1-6.85-7.91,13.81,13.81,0,0,1,1-11.68,17.31,17.31,0,0,1,9.95-8q11-3.84,22.21,6.22l12.22-13.74q-8.58-7.65-16-10.22t-17.12-.85l-5.29-15.24-13.61,4.73,5.29,15.24a47.7,47.7,0,0,0-9.71,8.43,33.9,33.9,0,0,0-6,9.71,29.94,29.94,0,0,0-2.13,10.55,33,33,0,0,0,16.42,28.72q6.72,4,24.16,5.55a130.34,130.34,0,0,1,14.16,2,46.58,46.58,0,0,1,8.89,2.62q6.36,3,9,10.72,3,8.63-.79,16a21,21,0,0,1-12.39,10.49q-8.79,3.06-15.75.07-6.81-3.3-14.42-13.91l-15.87,9.53q9.63,15.39,20.42,20.62t26.9,2.42l5.43,15.63,13.61-4.73L558,1590.28a40.61,40.61,0,0,0,16.29-20.83,38.89,38.89,0,0,0-.17-26.09A34.46,34.46,0,0,0,557.31,1523.47Z",
    fill: "#f8f8ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.67,
    cy: 952.55,
    fill: "#e9e7ff",
    r: 217.79
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.67,
    cy: 952.55,
    fill: "#d8d7f9",
    r: 171.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426,967q-3.3-6.63-11.13-14.93a229,229,0,0,0-20.42-18.72q-14.61-12-18.59-18.92A19.66,19.66,0,0,1,374,898.88,20.56,20.56,0,0,1,385.1,885.3q8.56-4.32,19-1.49,16.88,4.58,22.18,26.4L453,903.53q-4.15-16.68-11.17-26.1T421.37,862l6.29-23.28-20.78-5.62-6.3,23.28a70.75,70.75,0,0,0-19.08,2.23,50.93,50.93,0,0,0-15.58,6.93,44.86,44.86,0,0,0-11.51,11.23,46.73,46.73,0,0,0-7,15.18q-4.89,18,3.13,34.11,4.9,10.63,25.15,27.2a194.79,194.79,0,0,1,15.79,14.4,70,70,0,0,1,8.77,10.72q5.31,9.09,2.13,20.85-3.57,13.18-14.48,19.15-11.08,6.06-24.14,2.52-13.43-3.63-19.5-13.18-5.64-9.81-6.1-29.31l-27.6-1.6q-1.09,27.11,7.83,42.65t31.18,25.64l-6.46,23.87,20.78,5.63L370.5,1050q21.53.09,37.66-12a58.17,58.17,0,0,0,21.76-32.35Q435.47,985.09,426,967Z",
    fill: "#f8f8ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1974.76,
    cy: 1748.14,
    fill: "#e9e7ff",
    r: 362.32
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1974.76,
    cy: 1748.14,
    fill: "#d8d7f9",
    r: 284.53
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2051.06,1727.33q-10.62-6.27-29-10.79t-45.45-7.67q-31.23-3.52-43.07-9.62-12.11-6.23-16.54-20.06a34.24,34.24,0,0,1,3.18-29q8.05-13.76,25.21-19.26,27.68-8.88,54.83,16.8l31.19-33.43q-20.88-19.53-39.18-26.34t-42.49-3.14l-12.26-38.2-34.1,10.94,12.25,38.2a118.27,118.27,0,0,0-24.64,20.37,84.64,84.64,0,0,0-15.48,23.77,74.86,74.86,0,0,0-5.93,26.09,78.1,78.1,0,0,0,3.89,27.55q9.51,29.63,35.22,44.81,16.45,10.41,59.7,15.24a323.38,323.38,0,0,1,35.08,5.84q14.08,3.35,21.93,7,15.65,7.88,21.83,27.18,6.95,21.63-2.91,39.84-10,18.46-31.43,25.34-22,7.06-39.15-.77-16.74-8.61-35-35.42l-40,22.71q23,38.85,49.5,52.48t66.72,7.63l12.56,39.17,34.11-10.94-12.94-40.34q30.12-19.34,41.75-50.79,11.76-31.71,1.13-64.85Q2080.71,1744,2051.06,1727.33Z",
    fill: "#f8f8ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.94,724.48l-.16,26.91L1331,738.64l-13.06,24.59-40.84-12.48-.18,29-51.81-.3L859.52,2032.68l450.13,126.22,33.75-20.51,17.44,20.81,27.75-37.09c21.64,6.69,52.73,15.72,53.72,12.77,1.52-4.55,16.67-39.41,16.67-39.41s31.83-13.26,31.83-12.69,657.9-976.54,657.9-976.54l-16.45-19.16,16.7-22.68.12-20.7.17-29Z",
    fill: "#33aa5b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M974.06,1589.24l218-791S1734.65,923.1,1922,990.65L1320.12,2182l-420.67-208.8Z",
    fill: "#52e884"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.94,923.88s406,105.13,540.57,153.66L1285.07,2082.78,941.52,1903.2Z",
    fill: "#33aa5b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1663.35,1250.58a11.49,11.49,0,0,1-7.49-2.78,144.72,144.72,0,0,1-23.76-193.19,11.48,11.48,0,0,1,18.75,13.25,121.77,121.77,0,0,0,20,162.54,11.48,11.48,0,0,1-7.49,20.18Z",
    fill: "#1c7c3c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.3,1102.45a11.48,11.48,0,0,1-1.33-22.88,121,121,0,0,0,106.81-115.94,11.48,11.48,0,1,1,23,.8,143.94,143.94,0,0,1-127.08,137.94A12.37,12.37,0,0,1,1208.3,1102.45Z",
    fill: "#1c7c3c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.73,2036.47a11.47,11.47,0,0,1-9.47-17.94c20.68-30.38,59-47.42,95.46-42.4a11.48,11.48,0,1,1-3.13,22.75c-28-3.86-57.46,9.23-73.36,32.57A11.44,11.44,0,0,1,1212.73,2036.47Z",
    fill: "#1c7c3c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.34,1927.35a11.63,11.63,0,0,1-3-.39,11.48,11.48,0,0,1-8.15-14,78,78,0,0,0-19.81-73.81,11.48,11.48,0,0,1,16.26-16.21c24.56,24.64,34.67,62.28,25.74,95.91A11.48,11.48,0,0,1,1009.34,1927.35Z",
    fill: "#1c7c3c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1297.16,
    cy: 1490.15,
    fill: "#4ec676",
    rx: 184.49,
    ry: 111.88,
    transform: "rotate(-69.16 1297.046 1490.127)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 815.36,
    cy: 2115.59,
    fill: "#c12708",
    rx: 43,
    ry: 210.26,
    transform: "rotate(-73.84 815.308 2115.56)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M943,2112.88s116.48-56.58,169-189.82,41.81-191.93,41.81-191.93,39.1-49.76,60.22-110.23-30.43-105.88-41.73-98.5S1067.94,1573,1047.11,1594,985,1664.25,985,1664.25l-10.94-75,50.65-186s-100.08,13.41-109.51,35.24-75.45,136.3-99.92,162.17S700,2015.36,697.49,2033.25,661.8,2133.9,661.8,2133.9l259.72,70.72Z",
    fill: "#fccfbb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.32,2174.12h0c-6.61,22.81-102.39,15.1-213.92-17.23s-196.6-77-190-99.83h0l-48.17,166.21c-6.61,22.81,78.45,67.5,190,99.83s207.31,40,213.92,17.22l48.17-166.2Z",
    fill: "#ff401a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M948.34,1714.15a9.27,9.27,0,0,1-4.82-14.68c25.68-32.49,99.21-113.13,102.33-116.55a9.26,9.26,0,1,1,13.68,12.48c-.76.83-76.21,83.57-101.49,115.55A9.25,9.25,0,0,1,948.34,1714.15Z",
    fill: "#ee7354"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M988.64,1549.45a10.56,10.56,0,0,1-4.36-.16,11.21,11.21,0,0,1-8.14-13.41c11.14-48.34,49.23-173.23,50.85-178.52a10.8,10.8,0,0,1,13.65-7.23,11.23,11.23,0,0,1,7.19,14c-.39,1.29-39.48,129.42-50.44,177A10.89,10.89,0,0,1,988.64,1549.45Z",
    fill: "#33aa5b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.36,739.4c-14.24-59.71-29-120.75-62.43-172.26S916.65,456.9,855.28,458.6c104.26-74.38,180.27-187.41,209.81-312-9.12,129.83,87.36,264.56,207.3,315.09C1164.62,529.81,1070.73,612.59,1057.36,739.4Z",
    fill: "#fdf251"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M837.15,953.82c-16.51-27.28-33.51-55.11-58.19-75.29S722.77,836.42,692.69,847A280.56,280.56,0,0,0,747,659.42c16.07,65.65,85.14,117,152.47,123C857,833.16,823.65,889,837.15,953.82Z",
    fill: "#fdf251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/Two.28e9b01c5e52e70332aa9a629df95200.svg";
export { ForwardRef as ReactComponent };